import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center d-print-none" }
const _hoisted_2 = { class: "col-1 col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = { class: "col-11 col-xl-8 col-lg-7 col-md-6" }
const _hoisted_5 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_6 = { class: "dropdown profile-dropdown" }
const _hoisted_7 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = {
  class: "title d-none d-lg-block ms-10 ms-lg-15 text-truncate",
  style: {"max-width":"150px"}
}
const _hoisted_9 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_10 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_11 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_12 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_13 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_14 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_15 = { class: "text-body-secondary fw-semibold transition position-relative" }

import {  ref, onMounted, reactive } from "vue";
import { useRouter } from 'vue-router';
import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
import stateStore from "../../utils/store";
import { getUser } from '@/utils/funcoes';
import * as service from "@/services/usuariosService";
import ImgUsuario from "@/components/Imagens/ImgUsuario.vue";

import { useUserStore } from "@/stores/userStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {


const userStore = useUserStore();

const stateStoreInstance = stateStore;
const isSticky = ref(false);

const controle = reactive({
  usuario: {} as service.Usuario
});


onMounted(() => {
  window.addEventListener("scroll", () => {
    let scrollPos = window.scrollY;
    isSticky.value = scrollPos >= 100;
  });
});



onMounted(() => {
  controle.usuario = getUser() as any;
})

var router = useRouter();

const sair = () => {

  service.logout();
  router.push({ name: 'LoginPage' })
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
    'header-area bg-white d-print-none text-center text-md-start pt-5 pb-5 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-5 position-fixed',
    { sticky: isSticky.value },
  ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(LightDarkSwtichBtn),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, [
              _createVNode(ImgUsuario, {
                usuarioId: controle.usuario?.usuarioId,
                class: "rounded imgUsuario",
                width: "32",
                height: "32",
                alt: "admin"
              }, null, 8, ["usuarioId"]),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(userStore).getUser?.nomeUsuario), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(userStore).getTipo), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", _hoisted_13, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "flaticon-user-2" }, null, -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" Minha conta ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-setting" }, null, -1)),
                  _cache[6] || (_cache[6] = _createTextVNode(" Configurações ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/profile-settings",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-warning" }, null, -1)),
                  _cache[8] || (_cache[8] = _createTextVNode(" Suporte ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/support-desk-card",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", {
                  class: "text-body-secondary fw-semibold transition position-relative",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (sair()))
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "flaticon-logout" }, null, -1),
                  _createTextVNode(" Sair ", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})